enum SystemEvent {
  DeliverRemoteSigningMessage = '00000000-0000-0000-0000-000000000006',
  CaseAcknowledgment = '00000000-0000-0000-0000-000000000009',
  AddAttachment = '00000000-0000-0000-0000-000000000002',
  CaseStatusV2 = '00000000-0000-0000-0000-000000000020',
  TimerTrigger = '00000000-0000-0000-0000-000000000023',
  RequirementNoteAdded = '00000000-0000-0000-0000-000000000031',
  RequirementStatusChange = '00000000-0000-0000-0000-000000000032'
}

export { SystemEvent };
